"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfoBarMessageSource;
(function (InfoBarMessageSource) {
    InfoBarMessageSource[InfoBarMessageSource["Compose"] = 0] = "Compose";
    InfoBarMessageSource[InfoBarMessageSource["Extensibility"] = 1] = "Extensibility";
    InfoBarMessageSource[InfoBarMessageSource["ReadingPane"] = 2] = "ReadingPane";
})(InfoBarMessageSource = exports.InfoBarMessageSource || (exports.InfoBarMessageSource = {}));
var InfoBarMessageRank;
(function (InfoBarMessageRank) {
    InfoBarMessageRank[InfoBarMessageRank["Safety"] = 0] = "Safety";
    InfoBarMessageRank[InfoBarMessageRank["Error"] = 1] = "Error";
    InfoBarMessageRank[InfoBarMessageRank["Info"] = 2] = "Info";
})(InfoBarMessageRank = exports.InfoBarMessageRank || (exports.InfoBarMessageRank = {}));
var InfoBarMessageColor;
(function (InfoBarMessageColor) {
    InfoBarMessageColor[InfoBarMessageColor["Grey"] = 0] = "Grey";
    InfoBarMessageColor[InfoBarMessageColor["Red"] = 1] = "Red";
    InfoBarMessageColor[InfoBarMessageColor["Green"] = 2] = "Green";
    InfoBarMessageColor[InfoBarMessageColor["Yellow"] = 3] = "Yellow";
})(InfoBarMessageColor = exports.InfoBarMessageColor || (exports.InfoBarMessageColor = {}));
//# sourceMappingURL=InfoBarMessageViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-info-bar/lib/schema/InfoBarMessageViewState.js
// module id = 2643
// module chunks = 0 3 4 17 45